import { F0TagStatus, StatusVariant } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import type {
  BenefitAvailabilityStatus,
  BenefitSetupStatus,
} from 'modules/benefits/lib/benefitListings'

interface Props {
  availability: BenefitAvailabilityStatus
  setupStatus: BenefitSetupStatus | undefined
}

export const BenefitStatusTag = ({ availability, setupStatus }: Props) => {
  const getStatusText = () => {
    switch (availability) {
      case 'active':
        switch (setupStatus) {
          case 'pending_setup':
            return i18n.t('benefits.homepage.benefit.pending_setup')
          case 'pending_enrollment':
            return i18n.t('benefits.homepage.benefit.pending_enrollment')
          case 'pending_activation':
            return i18n.t('benefits.homepage.benefit.pending_activation')
          default:
            return i18n.t('benefits.homepage.benefit.active')
        }
      case 'available':
        return i18n.t('benefits.homepage.benefit.available')
      case 'pending':
        return i18n.t('benefits.homepage.benefit.pending')
      default:
        return i18n.t('benefits.homepage.benefit.not_active')
    }
  }

  const getStatusVariant = (): StatusVariant => {
    switch (availability) {
      case 'active':
        return setupStatus === undefined
          ? 'positive'
          : setupStatus === 'active'
          ? 'positive'
          : 'warning'
      case 'available':
        return 'info'
      case 'pending':
        return 'info'
      default:
        return 'critical'
    }
  }

  return <F0TagStatus text={getStatusText()} variant={getStatusVariant()} />
}
